import ContentControlStudioOperation from "./content-control-studio-operation";

export default class ContentControlStudioCompositeOperation extends ContentControlStudioOperation {
  private subOperations: ContentControlStudioOperation[] = [];

  addOperation(operation: ContentControlStudioOperation): void {
    this.subOperations.push(operation);
  }

  async do(): Promise<void> {
    for (const operation of this.subOperations) {
      await operation.do();
    }
  }

  async undo(): Promise<void> {
    for (let i = this.subOperations.length - 1; i >= 0; i--) {
      await this.subOperations[i].undo();
    }
  }
}
